'use es6';

export const UNREVIEWABLE_ALERT_ID = 'UNREVIEWABLE_APP_NOTIFICATION';
export const UnreviewableReasons = {
  PUBLIC_USER: 'PUBLIC_USER',
  NOT_INSTALLED: 'NOT_INSTALLED',
  UNINSTALLED: 'UNINSTALLED',
  LIMIT_REACHED: 'LIMIT_REACHED',
  ALREADY_REVIEWED: 'ALREADY_REVIEWED',
  PROVIDER_USER: 'PROVIDER_USER',
  TEST_PORTAL_USER: 'TEST_PORTAL_USER'
};